import React from "react";
import "./style.css";

export default function LeftNavLink({ linkLabel, linkClass }) {
  return (
    <span className={`left-nav__link ${linkClass || ""}`}>
      <span className="flex__parent">
        <span className="nav-bullet">•</span>
        <span className="flex__child">
          <span className="text-elipsis">{linkLabel}</span>
        </span>
      </span>
    </span>
  );
}
